import type { ReactNode } from "react";
import { GfgButton } from "@/components/ui/GfgButton";

interface RedemptionCtaShelfProps {
  label: string;
  /** Trailing icon (the parent resolves send-vs-arrow from the active phase). */
  endIcon: ReactNode;
  onClick: () => void;
}

/**
 * Phone-only sticky bottom CTA shelf (RFW-7). The inline desktop CTAs are hidden on
 * phones; this full-width pill carries the active phase's primary action. Purely
 * presentational — the parent owns which label/icon/action the phase dictates.
 */
export default function RedemptionCtaShelf({ label, endIcon, onClick }: RedemptionCtaShelfProps) {
  return (
    <div className="fixed inset-x-0 bottom-0 z-25 flex border-card-border border-t bg-white px-4 pt-3 pb-[max(12px,env(safe-area-inset-bottom))] shadow-[0_-6px_20px_rgba(51,44,34,0.06)] sm:hidden">
      <GfgButton
        variant="primary"
        className="flex-1 rounded-full py-3.75 text-[13px]"
        endIcon={endIcon}
        onClick={onClick}
      >
        {label}
      </GfgButton>
    </div>
  );
}
